module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/generic-list/generic-list.component.scss
// module id = ./src/app/shared-components/generic-list/generic-list.component.scss
// module chunks = main